import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardClaim } from '@lsq-frontend/remote-services/enterprise/common';
import { startOfMonth } from 'date-fns';
import { PopoverPlacement } from 'ngx-smart-popover';
import { UserService } from '@lsq-frontend/angular-shared/features/user-service';
import {
    ClaimService,
    Color,
    forLifeOf,
    Icons,
    LifecycleAware,
    ResponsiveService
} from '@lsq-frontend/common-ui';

@LifecycleAware()
@Component({
    selector: 'insights-overview',
    templateUrl: './insights-overview.component.html',
    styleUrls: ['./insights-overview.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class InsightsOverviewComponent implements OnInit, OnDestroy {
    public isMobile = false;
    public claim = DashboardClaim;
    public color = Color;
    public placement = PopoverPlacement;
    public startOfMonth = startOfMonth;
    public icons = Icons;

    constructor(
        private _claimService: ClaimService,
        private _responsiveService: ResponsiveService,
        private _router: Router,
        private _userService: UserService
    ) {}

    public ngOnInit(): void {
        this._responsiveService.smBelow.pipe(forLifeOf(this)).subscribe((isMobile) => {
            this.isMobile = isMobile;
        });
    }

    public ngOnDestroy(): void {}
}
